import { playStimulusAudio } from '../../common/stimulus/stimulusButtonActions';
import { GENERAL_AUDIO_DELAY } from '../../constants/time';
import selectors from '../../rootSelectors';
import { VOCAB_BD_FETCH_RETRY } from '../../common/api/apiRetryGetConstants';
import { highlightPossibleResponse, playResponseAudio } from '../../common/questions/questionsActions';
import VocaboServiceClient from '../../common/clients/VocaboServiceClient';
import { fetchContent } from '../vocabActions';
import { VOCAB_GRADES_WITH_AUTOPLAY } from '../vocabConstants';

export const fetchVocabBDContent = () => fetchContent(VocaboServiceClient.MEASURES.BD, VOCAB_BD_FETCH_RETRY);

export const autoplayScript = (questionIndex, stimulusAudio, pageType) => async (dispatch, getState) => {
    const state = getState();
    const grade = selectors.getGrade(state);

    if (VOCAB_GRADES_WITH_AUTOPLAY.includes(grade)) {
        const possibleResponses = selectors.getVocabBDPossibleResponses(
            state,
            pageType,
            questionIndex,
        );

        await dispatch(playStimulusAudio([stimulusAudio], GENERAL_AUDIO_DELAY));
        await possibleResponses.reduce(async (promise, response, index) => {
            await promise;
            dispatch(highlightPossibleResponse(index));
            await dispatch(playResponseAudio(
                response.audio,
                index,
                GENERAL_AUDIO_DELAY,
            ));
        }, Promise.resolve());
        dispatch(highlightPossibleResponse());
    }

    return Promise.resolve();
};
